import { Component, inject, signal, TemplateRef, WritableSignal } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatRipple } from "@angular/material/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgTemplateOutlet } from "@angular/common";
import { ApiService } from "../../../../api/services/api.service";
import { take } from "rxjs";
import { RentalDto } from "../../../../api/models/fraud.models";

@Component({
    selector: 'app-dialog-cancel-invoice',
    imports: [
        MatDialogContent,
        MatDialogTitle,
        MatIcon,
        MatRipple,
        TranslateModule,
        MatDialogClose,
        NgTemplateOutlet
    ],
    templateUrl: './dialog-cancel-invoice.component.html',
    styleUrl: './dialog-cancel-invoice.component.scss'
})
export class DialogCancelInvoiceComponent {
  readonly data: { walletHeaderTemplate: TemplateRef<any>; rental: RentalDto } = inject<{
    walletHeaderTemplate: TemplateRef<any>;
    rental: RentalDto
  }>(MAT_DIALOG_DATA);

  private readonly _matDialogRed: MatDialogRef<DialogCancelInvoiceComponent> = inject(MatDialogRef<DialogCancelInvoiceComponent>);

  private readonly _apiService: ApiService = inject(ApiService);

  readonly loading: WritableSignal<boolean> = signal<boolean>(false);

  cancelInvoice(): void {
    this.loading.set(true);
    if (this.data.rental.invoiceId) {
      this._apiService
        .cancelInvoice(this.data.rental.invoiceId)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this._matDialogRed.close(true);
          },
          error: () => {
            this.loading.set(false);
          }
        });
    }
  }
}
